/* Family Switcher
 * - Mueve los bloques (familia + conexiones) encima del selector de variantes
 * - Cambia de producto via Shopify Section Rendering (sin recargar)
 * - Mantiene el fallback nativo si algo falla (navegación normal)
 */

(function () {
  var DEBUG = false;

  // Utilidades
  var $ = function (sel, ctx) { return (ctx || document).querySelector(sel); };
  var $$ = function (sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); };
  var log = function(){ if (DEBUG) try { console.log.apply(console, ['[FS]'].concat([].slice.call(arguments))); } catch(e){} };

  // Selector donde insertaremos nuestros bloques (encima)
  var PRODUCT_FORM_CANDIDATES = [
    '.product-form',
    'form[action^="/cart/add"]',
    '[data-product-form]',
    'product-form',
    '.product__info-container form',
    '.product-form-container',
    '.product-info__block form'
  ];

  // Evita doble click mientras refrescamos
  var isSwapping = false;

  function closestShopifySectionId(el) {
    var sec = el && el.closest('[id^="shopify-section-"]');
    return sec ? sec.id.replace('shopify-section-', '') : null;
  }

  function findVariantMount() {
    for (var i = 0; i < PRODUCT_FORM_CANDIDATES.length; i++) {
      var el = $(PRODUCT_FORM_CANDIDATES[i]);
      if (el) {
        log('Mount found at', PRODUCT_FORM_CANDIDATES[i]);
        return el;
      }
    }
    log('Mount fallback to H1');
    return $('h1') || document.body;
  }

  // ——— Secciones a refrescar ———
  // Tomamos el main (donde está el form) y nuestras dos secciones opcionales
  function getSectionIds() {
    var mount = findVariantMount();
    var mainId = closestShopifySectionId(mount);

    var fsSection = $('[id^="fs-section-"]');
    var pcSection = $('[id^="pc-section-"]');

    function extractId(node, prefix) {
      if (!node) return null;
      var rawId = node.getAttribute('id') || '';
      return rawId.replace(prefix, '');
    }

    var fsId = extractId(fsSection, 'fs-section-');
    var pcId = extractId(pcSection, 'pc-section-');

    var ids = [];
    if (mainId) ids.push(mainId);
    if (fsId) ids.push(fsId);
    if (pcId) ids.push(pcId);

    return { list: ids, mainId: mainId, fsId: fsId, pcId: pcId };
  }

  // Reemplaza el HTML de una sección Shopify por ID
  function replaceSectionFromHTML(sectionId, html) {
    var tmp = document.createElement('div');
    tmp.innerHTML = html;
    var incoming = tmp.querySelector('#shopify-section-' + sectionId);
    var current  = document.getElementById('shopify-section-' + sectionId);
    if (incoming && current) {
      current.replaceWith(incoming);
      return true;
    }
    return false;
  }

  // Shopify: GET /products/{handle}?sections=a,b,c  -> { "a": "<html>", "b": "<html>", ... }
  function fetchSectionsForHandle(handle, sectionIds) {
    if (!sectionIds || !sectionIds.list || !sectionIds.list.length) {
      return Promise.reject(new Error('No sections to fetch'));
    }
    var url = '/products/' + encodeURIComponent(handle) + '?sections=' + encodeURIComponent(sectionIds.list.join(','));
    log('Fetching sections:', url);
    return fetch(url, { credentials: 'same-origin' }).then(function (r) { return r.json(); });
  }

  // Clona y monta nuestros bloques justo encima del mount
  function remountBlocks() {
    var mount = findVariantMount();
    if (!mount || !mount.parentNode) return;

    // Limpia clones previos
    $$('.fs-root[data-mounted="true"], .pc-root[data-mounted="true"]').forEach(function (n) {
      if (n.parentNode) n.parentNode.removeChild(n);
    });

    // Clona (si existen) y monta
    var fsSrc = $('[data-fs-root]');
    if (fsSrc) {
      var clone = fsSrc.cloneNode(true);
      clone.setAttribute('data-mounted', 'true');
      mount.parentNode.insertBefore(clone, mount);
    }

    var pcSrc = $('[data-pc-root]');
    if (pcSrc) {
      var clone2 = pcSrc.cloneNode(true);
      clone2.setAttribute('data-mounted', 'true');
      mount.parentNode.insertBefore(clone2, mount);
    }
    log('Blocks remounted');
  }

  function setActive(handle) {
    $$('.fs-link').forEach(function (a) {
      var active = a.getAttribute('data-handle') === handle;
      a.classList.toggle('is-active', active);
      a.setAttribute('aria-current', active ? 'true' : 'false');
    });
  }

  function updateTitleFromMain() {
    var h1 = $('h1');
    if (!h1) return;
    var parts = document.title.split(' – ');
    var suffix = parts.length > 1 ? parts.slice(1).join(' – ') : '';
    document.title = h1.textContent.trim() + (suffix ? ' – ' + suffix : '');
  }

  // Señales útiles para que el theme re-inicialice variantes, sliders, etc.
  function reinitTheme() {
    // Algunos themes escuchan estos eventos:
    window.dispatchEvent(new CustomEvent('product:reinit'));
    document.dispatchEvent(new Event('shopify:section:load')); // genérico
  }

  function afterSwap(handle) {
    remountBlocks();
    history.pushState({ handle: handle }, '', '/products/' + handle);
    setActive(handle);
    updateTitleFromMain();
    reinitTheme();
    isSwapping = false;
  }

  function swapForHandle(handle, hrefFallback) {
    if (isSwapping) return;
    isSwapping = true;

    var sectionIds = getSectionIds();
    if (!sectionIds.mainId) {
      log('No main section found, navigating normally');
      window.location.href = hrefFallback;
      return;
    }

    fetchSectionsForHandle(handle, sectionIds)
      .then(function (json) {
        var changed = 0;
        sectionIds.list.forEach(function (id) {
          if (json[id]) {
            var ok = replaceSectionFromHTML(id, json[id]);
            if (ok) changed++;
          }
        });
        if (!changed) throw new Error('No sections replaced');
      })
      .then(function () {
        afterSwap(handle);
      })
      .catch(function (err) {
        log('Swap failed, navigating', err);
        window.location.href = hrefFallback;
      });
  }

  function onClick(e) {
    var link = e.target && e.target.closest && e.target.closest('.fs-link, .pc-link');
    if (!link) return;

    var handle = link.getAttribute('data-handle');
    if (!handle) return;

    e.preventDefault();
    swapForHandle(handle, link.href);
  }

  function onPopState() {
    var m = location.pathname.match(/\/products\/([^/?#]+)/);
    if (!m) return;
    swapForHandle(m[1], location.href);
  }

  function init() {
    remountBlocks();
    document.addEventListener('click', onClick);
    window.addEventListener('popstate', onPopState);
    log('Initialized');
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
